<template>
    <div>
        <div style="margin-bottom:5px">
            <el-input
                v-model.trim="formInline.contact"
                placeholder="联系人"
                class="handle-input mr10"
                size="small"
            ></el-input>
            <el-input
                v-model.trim="formInline.contactPhone"
                placeholder="联系电话"
                class="handle-input mr10"
                size="small"
            ></el-input>
            <el-button type="success" @click="handleSearch" size="small">查询</el-button>
            <el-button type="success" @click="handleAdd" size="small">新增地址</el-button>
        </div>
        <div>
            <table v-if="address">
                <tr class="th">
                    <td v-if="isFromOrder"></td>
                    <td width="100px">收货人</td>
                    <td width="150px">手机号</td>
                    <td>收货地址</td>
                    <td width="100px">是否默认</td>
                    <td width="200px">操作</td>
                </tr>
                <tbody>
                    <tr v-for="(item, index) in address" :key="index">
                        <td v-if="isFromOrder" class="radio">
                            <el-radio v-model="currentAddress" :label="item.id"></el-radio>
                        </td>
                        <td>{{ item.contact }}</td>
                        <td>{{ item.contactPhone }}</td>
                        <td>{{ item.province }}{{ item.city }}{{ item.area }}{{ item.address }}</td>
                        <td>
                            <span v-if="item.defaultState === 1"
                                ><i class="el-icon-check"></i
                            ></span>
                        </td>
                        <td>
                            <el-button type="success" size="mini" @click="handleUpdate(item)"
                                >修改</el-button
                            >
                            <el-button type="danger" size="mini" @click="handleDelete(item)"
                                >删除</el-button
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="table-empty" v-if="!address || address.length === 0">
                <i class="el-icon-document-copy"></i>
                <p>暂无数据</p>
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                v-if="address"
                background
                layout="prev, pager, next,total"
                :total="pageTotal"
                :page-size="formInline.size"
                :current-page.sync="formInline.current"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
        <el-dialog
            title="收货地址"
            :visible.sync="dialogFormVisible"
            width="500px"
            :append-to-body="isFromOrder"
            :close-on-click-modal="false"
        >
            <el-form ref="form" :model="form" label-width="110px" :rules="rules" size="small">
                <el-form-item label="收货人" prop="contact">
                    <el-input v-model="form.contact"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="contactPhone">
                    <el-input v-model="form.contactPhone"></el-input>
                </el-form-item>
                <el-form-item label="省市区" prop="pca">
                    <el-cascader
                        style="width: 100%;"
                        :options="areaAddress"
                        :props="props"
                        ref="cascaderAddr"
                        v-model="form.pca"
                        @change="handleAddressFun"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>
                <el-form-item label="设为默认地址" prop="defaultAddress">
                    <el-switch
                        :active-value="1"
                        :inactive-value="0"
                        v-model="form.defaultState"
                    ></el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="handleSubmit('form')" size="small"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as apis from '../../fetch/user';
import { address } from '../../fetch/address';

export default {
    name: 'Address',
    props: ['from'],
    data() {
        return {
            type: 1,
            currentAddress: null,
            formInline: {
                size: 10,
                current: 1,
            },
            dialogFormVisible: false,
            form: {
                contact: '',
                address: '',
                contactPhone: '',
                pca: '',
                defaultAddress: false,
                isInvoiceAddress: false,
                topicName: '',
                defaultState: 0,
            },
            rules: {
                contact: [{ required: true, message: '请输入收货人', trigger: 'blur' }],
                address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
                contactPhone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
                pca: [{ required: true, message: '请选择省市区', trigger: 'blur' }],
            },
            formLabelWidth: '120px',
            address: null,
            props: {
                value: 'areaCode',
                label: 'areaName',
                children: 'children',
            },
        };
    },
    computed: {
        isFromOrder() {
            return this.from === 'order';
        },
        areaAddress() {
            return address;
        },
    },
    methods: {
        handleAddressFun: function() {
            this.pcaLabel = this.$refs.cascaderAddr.getCheckedNodes()[0].pathLabels;
        },
        getAddress() {
            this.formInline.type = this.type;
            apis.getAddress(this.formInline).then(res => {
                this.address = res.data.records;
                this.pageTotal = res.data.total;
            });
        },
        handleSearch() {
            this.formInline.current = 1;
            this.getAddress();
        },
        handleCurrentChange(page) {
            this.getAddress(this.formInline.orderNo, page);
        },
        handleSubmit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.form.type = this.type;

                    this.form.provinceCode = this.form.pca[0];
                    this.form.province = this.pcaLabel[0];
                    this.form.cityCode = this.form.pca[1];
                    this.form.city = this.pcaLabel[1];

                    if (this.form.pca.length > 2) {
                        this.form.areaCode = this.form.pca[2];
                        this.form.area = this.pcaLabel[2];
                    } else {
                        this.form.areaCode = '';
                        this.form.area = '';
                    }
                    if (this.form.id) {
                        apis.updateAddress(this.form).then(() => {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                            });
                            this.dialogFormVisible = false;
                            this.getAddress();
                        });
                    } else {
                        apis.addAddress(this.form).then(() => {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                            });
                            this.dialogFormVisible = false;
                            this.getAddress();
                        });
                    }
                }
            });
        },
        handleAdd() {
            this.form = {
                defaultState: 0,
            };
            this.dialogFormVisible = true;
        },
        handleUpdate(item) {
            this.form = { ...item };
            //this.form = { ...item, pca: [item.province, item.city, item.area] };
            this.form.pca = [item.provinceCode, item.cityCode];
            if (item.areaCode && item.areaCode != '') {
                this.form.pca.push(item.areaCode);
            }
            console.log(this.form.pca);
            this.pcaLabel = [item.province, item.city, item.area];
            this.dialogFormVisible = true;
        },
        handleDelete(item) {
            this.$confirm('确认删除此地址？').then(() => {
                apis.deleteAddress({ ids: [item.id] }).then(() => {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                    });
                    this.getAddress();
                });
            });
        },
    },
    mounted() {
        this.getAddress();
    },
};
</script>

<style scoped lang="less">
.radio label {
    width: 20px;
    height: 100%;
    overflow: hidden;
}
.handle-input {
    width: 140px;
    margin-right: 10px;
    display: inline-block;
}
</style>
